import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { FC } from 'react'

export const Asset: FC<{
    asset: TAsset
}> = ({ asset: { asset_type, hostname } }) => {
    if (!asset_type || !hostname) return null

    return (
        <View wrap={false} style={styles.asset}>
            <Text>{`${asset_type}: ${hostname}`}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    asset: {
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
    },
})
